export function lazy<T>(builder: () => T): () => T {
  let it: T | undefined
  return () => {
    if (it === undefined) {
      it = builder()
    }
    return it
  }
}
